import React from "react";
import {IconContext} from "react-icons";
import {FaTimes} from "react-icons/all";

/**
 * React Component properties
 */
type Props = {
  // data
  isVisible: boolean;
  children: any;

  // function
  onHide: () => void;
};

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This functions is a general component for a PopUP above other content
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function PopUp(props: Props) {
  if (props.isVisible) {
    return (
      <div className={"pop_up_container"}>
        <div className={"pop_up_inner_container"}>
          <div
            className={"close_pop_up_icon_container"}
            onClick={() => props.onHide()}
          >
            <IconContext.Provider
              value={{ color: "#616161", className: "close_pop_up_icon" }}
            >
              <FaTimes />
            </IconContext.Provider>
          </div>

            {props.children}
        </div>
      </div>
    );
  } else {
    return <div />;
  }
}
